import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { OpenZenDeskModule } from '@fantaz/shared/directives/open-zendesk';

@Component({
  selector: 'fantaz-attempts-exceeded',
  templateUrl: './attempts-exceeded.component.html',
  styleUrls: ['./attempts-exceeded.component.scss'],
  standalone: true,
  imports: [MaterialModule, OpenZenDeskModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttemptsExceededComponent {}
